// hooks/useReportBug.ts
import axios from "axios";
import { END_POINT } from "config/environment";
import { useMutation } from "react-query";

export const QUERY_KEY_FOR_REPORT_BUG = "report_bug";

export interface ReportBugData {
  name: string;
  email: string;
  description: string;
  screenshot?: File | null;
}

const submitBugReport = async (data: ReportBugData): Promise<any> => {
  const url = `${END_POINT.BASE_URL}/report-bug`;

  if (data.screenshot) {
    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("email", data.email);
    formData.append("description", data.description);
    formData.append("screenshot", data.screenshot, data.screenshot.name);

    formData.forEach((value, key) => {
    
    });

    try {
      const response = await axios.post(url, formData, {
        headers: {
          Accept: "application/json",
        },
        timeout: 30000,
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
            console.log(`📊 Upload progress: ${percentCompleted}%`);
          }
        },
      });

      if (response.data?.data?.screenshot_path === null) {
        console.warn(
          "⚠️ Screenshot path is null - file may not have been saved",
        );
      }

      return response.data;
    } catch (error) {
      console.error("❌ Upload failed:", error);
      throw error;
    }
  }

  const payload = {
    name: data.name,
    email: data.email,
    description: data.description,
  };

  const response = await axios.post(url, payload, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  return response.data;
};

export const useReportBug = () => {
  return useMutation(
    [QUERY_KEY_FOR_REPORT_BUG],
    (data: ReportBugData) => submitBugReport(data),
    {
      onSuccess: (data) => {
        console.log("✅ Bug report submitted successfully:", data);
        if (data?.data?.screenshot_path) {
          console.log("📸 Screenshot saved at:", data.data.screenshot_path);
        } else if (data?.data?.screenshot_path === null) {
          console.warn("⚠️ Screenshot was not saved by the server");
        }
      },
      onError: (err: any) => {
        console.error("❌ Failed to submit bug report:", err);
        if (axios.isAxiosError(err)) {
          console.error("❌ Response data:", err.response?.data);
          console.error("❌ Response status:", err.response?.status);
          console.error("❌ Response headers:", err.response?.headers);
        }
      },
      retry: 1,
    },
  );
};
